import { buttonClass } from "./ui/Button.jsx";

export const TONE = {
    OK: "ok",
    WAITING: "waiting",
    ATTENTION: "attention",
    SETUP: "setup",
    LOADING: "loading",
    UNAVAILABLE: "unavailable",
};

// The kit's buttons (ui/Button.jsx), under the names the source pages import.
export const primaryBtnCls = `${buttonClass("primary")} shrink-0`;
export const secondaryBtnCls = `${buttonClass("secondary")} shrink-0`;
export const ghostBtnCls = `${buttonClass("ghost")} shrink-0`;
export const dangerBtnCls = `${buttonClass("danger")} shrink-0`;

const TONE_STYLE = {
    [TONE.OK]: { pill: "bg-[color-mix(in_srgb,var(--ink)_8%,transparent)] text-[color:var(--ink)]", dot: "bg-[color:var(--green)]" },
    [TONE.WAITING]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--ink)]", dot: "bg-[color:var(--severity-medium)]" },
    [TONE.ATTENTION]: {
        pill: "bg-[color-mix(in_srgb,var(--danger)_14%,transparent)] text-[color:var(--ink)]",
        dot: "bg-[color:var(--danger)]",
    },
    [TONE.SETUP]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--muted)]", dot: "bg-[color:var(--line-strong)]" },
    [TONE.LOADING]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--muted)]", dot: "bg-[color:var(--line)]" },
    [TONE.UNAVAILABLE]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--muted)]", dot: "bg-[color:var(--line-strong)]" },
};

export function toneDotClass(tone) {
    return (TONE_STYLE[tone] ?? TONE_STYLE[TONE.SETUP]).dot;
}

export function StatusPill({ tone, label, pulse = false }) {
    const style = TONE_STYLE[tone] ?? TONE_STYLE[TONE.SETUP];
    return (
        <span
            className={`inline-flex shrink-0 items-center gap-[6px] whitespace-nowrap rounded-[5px] px-[8px] py-[3px] text-[11px] font-medium leading-[1.2] ${style.pill}`}
        >
            <span aria-hidden="true" className={`h-[7px] w-[7px] rounded-full ${style.dot} ${pulse ? "animate-pulse" : ""}`} />
            {label}
        </span>
    );
}

export function SourceLogo({ logo, size = 28, muted = false }) {
    if (!logo) return null;
    return (
        <svg
            viewBox={logo.viewBox}
            aria-hidden="true"
            className={`shrink-0 ${muted ? "text-[color:var(--muted)]" : "text-[color:var(--ink)]"}`}
            style={{ width: size, height: size }}
            xmlns="http://www.w3.org/2000/svg"
        >
            {logo.paths.map((d, index) => (
                <path key={index} d={d} fill="currentColor" />
            ))}
        </svg>
    );
}

export function Fact({ label, children, tone = null }) {
    const color =
        tone === "warning"
            ? "text-[color:var(--severity-medium)]"
            : tone === "muted"
              ? "text-[color:var(--muted)]"
              : "text-[color:var(--ink)]";
    return (
        <div className="grid min-w-0 gap-[3px]">
            <dt className="text-[12px] leading-[1.2] text-[color:var(--muted)]">{label}</dt>
            <dd className={`m-0 truncate text-[13px] ${color}`}>{children}</dd>
        </div>
    );
}
